import Marquee from "react-fast-marquee";

export const EditorialMarquee = ({ text = "Your HVAC System Should Be Engineered to Work — Not Hoped Into Working.", speed = 28 }) => (
  <section data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/10 bg-ink py-10 md:py-16">
    <Marquee speed={speed} gradient={false} autoFill>
      <span className="font-display text-6xl font-extrabold uppercase tracking-tight md:text-8xl">
        <span className="text-outline">&nbsp;{text}&nbsp;</span>
        <span className="mx-8 inline-block h-3 w-3 translate-y-[-14px] rotate-45 bg-brand-ember" />
      </span>
    </Marquee>
  </section>
);

export default EditorialMarquee;
